import { AppImage } from '@/components/common/AppImage';
import { cn } from '@/lib/utils';

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'default' | 'white';
}

export function Logo({
  className,
  size = 'md',
  variant = 'default',
}: LogoProps) {
  const sizeClasses = {
    sm: {
      container: 'h-6 w-6',
      text: 'text-base',
    },
    md: {
      container: 'h-8 w-8',
      text: 'text-xl',
    },
    lg: {
      container: 'h-12 w-12',
      text: 'text-3xl',
    },
  };

  return (
    <div className={cn('flex items-center space-x-3', className)}>
      <div
        className={cn(
          'flex items-center justify-center',
          sizeClasses[size].container
        )}
      >
        <AppImage
          src="/svg/Logo.svg"
          alt="Auction Chase Logo"
          shape="circle"
          size="lg"
          gradient
          className="h-full w-full"
          priority
        />
      </div>
      <span
        className={cn(
          'bg-gradient-to-r from-primary-600 to-accent-blue bg-clip-text font-bold text-transparent',
          sizeClasses[size].text,
          {
            'bg-none text-white': variant === 'white',
          }
        )}
      >
        Auction Chase
      </span>
    </div>
  );
}
